import { buildAuthLoginUrl } from '~/utils/buildAuthLoginUrl';
import type { RouteMiddleware } from '#app';

export const authMiddleware: RouteMiddleware = async (to) => {
  const { ssrContext, $protectedSlugs } = useNuxtApp();
  const slug = ensureArray(to.params.slug).filter(Boolean).join('/');

  if (!$protectedSlugs.value.includes(slug)) {
    return;
  }

  const { loggedIn } = useOidcAuth();
  const route = useRoute();

  if (!loggedIn.value) {
    if (!ssrContext) {
      navigateTo(buildAuthLoginUrl(route.path, route.query), {
        external: true
      });
    }
  }
};

export default defineNuxtRouteMiddleware(authMiddleware);
